<template>
    <span class="ml-2">
        <Button
            v-for="field in Object.keys(loopDefaults)"
            :key="field"
            :icon="basket && basket[field] ? 'pi pi-minus' : 'pi pi-plus'"
            :label="field"
            :class="
                basket && basket[field]
                    ? 'p-button-rounded p-button-outlined p-button-sm p-button-danger mx-2'
                    : 'p-button-rounded p-button-outlined p-button-sm mx-2'
            "
            @click="addRemoveField(field)"
        />
    </span>
    <div v-if="basket" class="loopRules inter-rule-spacing ml-4 mt-2">
        <div v-for="field in Object.keys(basket)" :key="field" class="my-3 mx-3">
            <div v-if="field !== 'type'">
                <span>{{ field }}: </span>
                <StandardDropdown
                    :modelValue="{ name: basket[field]['operator'] }"
                    :options="loopDefaults[field].operators.map((o) => ({ name: o }))"
                    placeholder="Select operation"
                    class="inter-rule-spacing"
                    @change="sendBasket(field, $event.value.name, basket[field]['value'])"
                />
                <component
                    :is="loopDefaults[field]['component']['name']"
                    :value="basket[field]['value']"
                    :operator="basket[field]['operator']"
                    class="inter-rule-spacing"
                    @handleValueChange="sendBasket(field, basket[field]['operator'], $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import StandardDropdown from '@/components/common/StandardDropdown.vue';
import { stringOperators } from '@/store/constants';
import IntRule from '@/components/listGeneration/query/ruleSuffix/IntRule.vue';
import TextRule from '@/components/listGeneration/query/ruleSuffix/TextRule.vue';
import DateRule from '@/components/listGeneration/query/ruleSuffix/DateRule.vue';
import StateRule from '@/components/listGeneration/query/ruleSuffix/StateRule.vue';

export default {
    name: 'DemographicBasketRule',
    props: ['basket', 'demographicBaskets'],
    emits: ['handleBasketChange'],
    components: {
        StandardDropdown,
        IntRule,
        TextRule,
        DateRule,
        StateRule,
    },
    data() {
        return {
            loopDefaults: {
                first_name: {
                    operators: stringOperators,
                    component: TextRule,
                },
                last_name: {
                    operators: stringOperators,
                    component: TextRule,
                },
                work_history: {
                    operators: stringOperators,
                    component: TextRule,
                },
            },
        };
    },
    watch: {
        demographicBaskets(newBasket) {
            this.fillBasket(newBasket);
        },
    },
    methods: {
        fillBasket(newBasket) {
            var updated_basket = { type: 'demographic_basket' };
            let fields = ['first_name', 'last_name', 'work_history'];
            for (let field of fields) {
                if (newBasket[field]) {
                    updated_basket[field] = {
                        type: 'demographic_basket_field',
                        value: this.demographicBaskets[field]['values'],
                        operator: this.demographicBaskets[field]['operator'],
                    };
                }
            }
            this.$emit('handleBasketChange', updated_basket);
        },
        addRemoveField(field) {
            let updated_basket = {};
            const default_operator = this.loopDefaults[field].operators[0];
            if (this.basket && this.basket[field]) {
                updated_basket = this.basket;
                delete updated_basket[field];
            } else if (this.basket) {
                updated_basket = this.basket;
                updated_basket[field] = {
                    value: null,
                    operator: default_operator,
                };
            } else {
                updated_basket[field] = {
                    value: null,
                    operator: default_operator,
                };
            }
            this.$emit('handleBasketChange', updated_basket);
        },
        sendBasket(field, operator, value) {
            const updated_basket = this.basket;
            updated_basket[field] = {
                type: 'demographic_basket_field',
                value: value,
                operator: operator,
            };
            this.$emit('handleBasketChange', updated_basket);
        },
    },
};
</script>

<style scoped>
.inter-rule-spacing {
    margin-right: 0.5rem;
}
.loopRules {
    border-left: dashed;
}
</style>
